import { pxToEm } from 'util/pxToEm';
import { Box, Typography } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';
import { Image, TruncateText } from 'components/lib';

export interface CalloutRowProps {
  action?: ReactNode;
  name: string;
  logoUrl: string;
  onClick?: () => void;
}

export const CalloutRow = ({
  action,
  name,
  logoUrl,
  onClick,
}: CalloutRowProps): ReactElement => {
  return (
    <Box mt={25} display="flex" alignItems="center">
      {action && <Box pr={16}>{action}</Box>}
      <Box
        display="flex"
        alignItems="center"
        onClick={onClick}
        sx={{
          '&:hover': {
            cursor: 'pointer',
            '.callout-text': {
              textDecoration: 'underline',
            },
          },
        }}
      >
        <Box width={50} minWidth={50} height={50}>
          <Image src={logoUrl} alt={name} width="100%" height="100%" />
        </Box>
        <Box ml={10} flex="1 1 auto" minWidth={0}>
          <TruncateText lines={2}>
            <Typography
              className="callout-text"
              sx={{
                color: theme => theme.palette.text.primary,
                fontSize: pxToEm(13),
                fontFamily: 'Poppins-Regular, Poppins',
                fontWeight: 400,
                wordBreak: 'break-word',
              }}
            >
              {name}
            </Typography>
          </TruncateText>
        </Box>
      </Box>
    </Box>
  );
};
